export const ETAZHI_BLACK_FRIDAY_CAROUSEL_OPTIONS = {
  spaceBetween: 16,
  slidesPerView: 4,
  slidesPerGroup: 4,
  allowTouchMove: false,
  className: 'etazhi-black-friday-offers-carousel',
  testId: 'EtazhiBlackFridayPromoOffersCarousel',
};
